import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PageHeader } from '@/components/layout'

/**
 * AdminPaymentsPage — M5 admin view of payments.
 *
 * NOTE: A server-side listing endpoint was not in scope for M5. This page
 * renders an empty-state + a "look up by payment id" input so the M5 refund
 * UX is reachable without a list view. Future milestone can add a list API.
 */
export const AdminPaymentsPage: React.FC = () => {
  const navigate = useNavigate()
  const [paymentId, setPaymentId] = React.useState('')

  return (
    <div>
      <PageHeader title="Payments" subtitle="Lookup and manage payments" />
      <div className="rounded-lg bg-white dark:bg-surface-card border border-gray-200 dark:border-white/5 p-5 space-y-3">
        <p className="text-sm text-gray-500 dark:text-text-muted">
          Masukkan payment ID untuk melihat detail dan memproses refund bila perlu.
        </p>
        <div className="flex gap-2">
          <input
            type="text"
            value={paymentId}
            onChange={(e) => setPaymentId(e.target.value)}
            placeholder="payment uuid"
            className="flex-1 border rounded px-3 py-2"
            data-testid="admin-payment-id"
          />
          <button
            type="button"
            onClick={() => {
              if (paymentId.trim()) navigate(`/admin/payments/${paymentId.trim()}`)
            }}
            className="px-4 py-2 bg-primary text-white rounded"
          >
            Buka
          </button>
        </div>
      </div>
    </div>
  )
}

export default AdminPaymentsPage
